export const REPORT_COMPONENTS= {
    "PERIOD_WITH_BODY":"PERIOD_WITH_BODY",
    "TEXT":"TEXT",
    "DATE_RANGE_PICKER":"DATE_RANGE_PICKER",
    "CATEGORY":"CATEGORY",
    "PERIOD":"PERIOD",
    "LINE_WITH_TEXT":"LINE_WITH_TEXT"
}
export const REPORT_SUBCOMPONENTS= {
    "SECONDARY_BUTTON":"SECONDARY_BUTTON",
    "BUTTON":"BUTTON",
   
}